import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { voiceVisualizerContainerStyles, voiceBarStyles } from "./styles";

interface VoiceVisualizerProps {
  isPlaying: boolean;
  className?: string;
}

export const VoiceVisualizer: React.FC<VoiceVisualizerProps> = ({
  isPlaying,
  className,
}) => {
  const [bars, setBars] = useState<number[]>([]);
  const animationRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    const initialBars = Array.from(
      { length: 40 },
      () => Math.random() * 0.8 + 0.3
    );
    setBars(initialBars);
  }, []);

  useEffect(() => {
    if (isPlaying) {
      const animate = () => {
        setBars((prevBars) =>
          prevBars.map((prevBar, index) => {
            const time = Date.now() * 0.005;
            const frequency = 0.1 + index * 0.04;
            const amplitude = 0.8 + Math.sin(time * 0.7 + index * 0.4) * 0.4;
            const baseHeight =
              Math.sin(time * frequency + index * 0.6) * amplitude + 0.5;

            const randomFactor = 0.25 + Math.sin(time * 3 + index) * 0.2;
            const finalHeight = baseHeight + randomFactor;

            return Math.max(Math.min(finalHeight, 1), 0.01);
          })
        );
        animationRef.current = requestAnimationFrame(animate);
      };
      animationRef.current = requestAnimationFrame(animate);
    } else {
      const reduceBars = () => {
        setBars((prevBars) => prevBars.map((bar) => Math.max(bar * 0.9, 0.1)));
        if (bars.some((bar) => bar > 0.15)) {
          animationRef.current = requestAnimationFrame(reduceBars);
        }
      };
      animationRef.current = requestAnimationFrame(reduceBars);
    }

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isPlaying, bars]);

  return (
    <Box className={className} sx={voiceVisualizerContainerStyles}>
      {bars.map((height, index) => (
        <Box key={index} sx={voiceBarStyles(height, isPlaying)} />
      ))}
    </Box>
  );
};
